module.exports = __webpack_public_path__ + "static/media/bsc.d70ec324.svg";